import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Dimensions } from "../components/common/SVGViewer";
import { MountType } from "./uploadedBoard";

export interface Focus {
  dimensions: Dimensions;
  mountType: MountType;
}

export interface SVGViewerController {
  focus: Focus | null;
}

export const svgViewerSlice = createSlice({
  name: "svgViewer",
  initialState: {
    focus: null,
  } as SVGViewerController,
  reducers: {
    setFocus: (
      state,
      action: PayloadAction<{
        focus: Focus | null;
      }>,
    ) => {
      state.focus = action.payload.focus;
    },
  },
});

export const { setFocus } = svgViewerSlice.actions;

export default svgViewerSlice.reducer;
